const local = {
    instruction: "Как серийный номер влияет на замок？",
    races :  ["Человек", "Эльф", "Орк", "Гном", "Нежить"],
    scale : ["немного", "Средняя", "большой"],
    serialNumber: "серийный номер",
    specialid: "особенная отметка",
    race: "раса",
    economic: "экономическая",
    military: "военная",
    cards: ["размер", "модель", "цвет", "модель знаки", "цвет знаки", "местоположение знаки", "раса", "отметка"],
};

export {local};